"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5449],{

/***/ 65195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* reexport */ icon; },
  "j": function() { return /* reexport */ iconProvider; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/provider/symbolWrapper.js



const HiddenSvg = styled_components_browser_esm/* default.svg */.ZP.svg`
  visibility: hidden;
  position: fixed;
  z-index: -1;
`;

const SymbolWrapper = ({
  icons
}) => {
  return /*#__PURE__*/react.createElement(HiddenSvg, null, Object.values(icons).map(icon => {
    return /*#__PURE__*/react.createElement("symbol", {
      key: icon.name,
      id: icon.name,
      viewBox: icon.viewBox
    }, icon.path);
  }));
};

 false ? 0 : void 0;
SymbolWrapper.defaultProps = {
  icons: {}
};
/* harmony default export */ var symbolWrapper = (SymbolWrapper);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/provider/iconProvider.js



const IconContext = /*#__PURE__*/(0,react.createContext)();
const {
  Provider
} = IconContext;

const IconProvider = ({
  children,
  logger = console
}) => {
  const [icons, setIcons] = (0,react.useState)({});

  const addIconSymbol = (name, icon) => {
    setIcons(prev => Object.assign({}, prev, {
      [name]: Object.assign({}, icon, {
        viewBox: (icon == null ? void 0 : icon.viewBox) || '0 0 24 24'
      })
    }));
    return icon.name;
  };

  return /*#__PURE__*/react.createElement(Provider, {
    value: {
      addIconSymbol,
      icons,
      logger
    }
  }, /*#__PURE__*/react.createElement(symbolWrapper, {
    icons: icons
  }), children);
};

IconProvider.defaultProps = {
  children: null
};
 false ? 0 : void 0;
/* harmony default export */ var iconProvider = (IconProvider);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@styled-system/prop-types/dist/index.esm.js
var index_esm = __webpack_require__(21302);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/utils/SvgIcon/index.js + 2 modules
var SvgIcon = __webpack_require__(45861);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/provider/ErrorBoundary.js



class ErrorBoundary extends react.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }

  render() {
    const {
      hasError
    } = this.state;
    return hasError ? /*#__PURE__*/react.createElement(react.Fragment, null, this.props.fallback) : this.props.children;
  }

}

 false ? 0 : void 0;
/* harmony default export */ var provider_ErrorBoundary = (ErrorBoundary);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/provider/useIcon.js



const useIcon = () => {
  return (0,react.useContext)(IconContext);
};

/* harmony default export */ var provider_useIcon = (useIcon);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/provider/icon.js








const Icon = _ref => {
  let {
    name,
    fill,
    color
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["name", "fill", "color"]);

  const [iconSymbolId, setIconSymbolId] = (0,react.useState)();
  const {
    addIconSymbol,
    icons,
    logger
  } = provider_useIcon() || {};
  const iconColor = fill || color;
  const propsWith = Object.assign({}, props, {
    color: iconColor,
    fill: iconColor
  });
  (0,react.useEffect)(() => {
    if (addIconSymbol) {
      if (icons[name]) setIconSymbolId(icons[name].name);else {
        __webpack_require__(70017)(`./${name}`).then(module => {
          const iconName = addIconSymbol(name, module.default);
          setIconSymbolId(iconName);
        }).catch(() => {
          logger.error(`invalid icon ${name}`);
        });
      }
    }
  }, [name]);

  if (addIconSymbol) {
    return !!iconSymbolId && /*#__PURE__*/react.createElement(SvgIcon/* default */.Z, propsWith, /*#__PURE__*/react.createElement("use", {
      xlinkHref: `#${iconSymbolId}`
    }));
  }

  if (typeof window !== 'object') return null;
  const TargetIcon = /*#__PURE__*/(0,react.lazy)(() => __webpack_require__(70017)(`./${name}`));
  return /*#__PURE__*/react.createElement(provider_ErrorBoundary, null, /*#__PURE__*/react.createElement(react.Suspense, {
    fallback: /*#__PURE__*/react.createElement(react.Fragment, null)
  }, /*#__PURE__*/react.createElement(TargetIcon, propsWith)));
};

 false ? 0 : void 0;
Icon.defaultProps = {
  color: '',
  fill: '',
  width: 24,
  height: 24
};
/* harmony default export */ var icon = (Icon);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/provider/index.js



/***/ }),

/***/ 45861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SvgIcon_SvgIcon; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@styled-system/prop-types/dist/index.esm.js
var index_esm = __webpack_require__(21302);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@styled-system/should-forward-prop/dist/index.esm.js + 2 modules
var dist_index_esm = __webpack_require__(62661);
// EXTERNAL MODULE: ../../node_modules/styled-system/dist/index.esm.js + 12 modules
var styled_system_dist_index_esm = __webpack_require__(68054);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui-styles/build/esm/index.js + 16 modules
var esm = __webpack_require__(55403);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/utils/SvgIcon/SvgIcon.styles.js




const Svg = (0,styled_components_browser_esm/* default */.ZP)('svg').withConfig({
  shouldForwardProp: dist_index_esm/* default */.ZP
})`
  ${esm/* color */.$_}
  ${styled_system_dist_index_esm/* space */.Dh}
  ${styled_system_dist_index_esm/* layout */.bK}
  ${esm/* cursor */.oc}
`;
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/utils/SvgIcon/SvgIcon.js



/* eslint-disable react/require-default-props */





function SvgIcon(_ref) {
  let {
    children,
    titleAccess
  } = _ref,
      props = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["children", "titleAccess"]);

  return /*#__PURE__*/react.createElement(Svg, (0,esm_extends/* default */.Z)({
    width: 24,
    height: 24
  }, props), titleAccess && /*#__PURE__*/react.createElement("title", null, titleAccess), children);
}

 false ? 0 : void 0;
/* harmony default export */ var SvgIcon_SvgIcon = (SvgIcon);
;// CONCATENATED MODULE: ../../node_modules/@magalu/stereo-ui-icons/build/esm/utils/SvgIcon/index.js


/***/ }),

/***/ 87685:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ createSvgIcon; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7896);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _SvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45861);




function createSvgIcon(childPath, displayName, defaults = {}) {
  const Component = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.memo(props => {
    const propsWith = Object.assign({}, defaults, props, {
      fill: props.fill || props.color || defaults.fill || defaults.color,
      color: props.color || props.fill || defaults.color || defaults.fill,
      viewBox: props.viewBox || defaults.viewBox || '0 0 24 24'
    });
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_SvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
      "data-testid": `${displayName}Icon`
    }, propsWith), childPath);
  });
   false ? 0 : void 0;
  Component.defaultProps = {
    color: null,
    fill: null,
    viewBox: null
  };
  Component.name = `${displayName}Icon`;
  Component.displayName = Component.name;
  Component.path = childPath;
  Component.viewBox = defaults.viewBox;
  return Component;
}

/***/ }),

/***/ 844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _createSvgIcon__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _createSvgIcon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87685);


/***/ })

}]);